import { useEffect } from 'react'

import { siteConfig } from '../content/siteContent.js'

function upsertMeta(selector, create, apply) {
  let node = document.head.querySelector(selector)
  if (!node) {
    node = create()
    document.head.appendChild(node)
  }
  apply(node)
}

export function usePageMeta(meta) {
  useEffect(() => {
    document.documentElement.lang = meta.htmlLang
    document.title = `${meta.title} · ${siteConfig.brandNameEn}`

    upsertMeta('meta[name="description"]', () => document.createElement('meta'), (node) => {
      node.setAttribute('name', 'description')
      node.setAttribute('content', meta.description)
    })
    upsertMeta('meta[property="og:title"]', () => document.createElement('meta'), (node) => {
      node.setAttribute('property', 'og:title')
      node.setAttribute('content', meta.title)
    })
    upsertMeta('meta[property="og:description"]', () => document.createElement('meta'), (node) => {
      node.setAttribute('property', 'og:description')
      node.setAttribute('content', meta.description)
    })
    upsertMeta('meta[property="og:url"]', () => document.createElement('meta'), (node) => {
      node.setAttribute('property', 'og:url')
      node.setAttribute('content', meta.canonical)
    })
    upsertMeta('meta[property="og:locale"]', () => document.createElement('meta'), (node) => {
      node.setAttribute('property', 'og:locale')
      node.setAttribute('content', meta.ogLocale)
    })
    upsertMeta('meta[name="twitter:title"]', () => document.createElement('meta'), (node) => {
      node.setAttribute('name', 'twitter:title')
      node.setAttribute('content', meta.title)
    })
    upsertMeta('meta[name="twitter:description"]', () => document.createElement('meta'), (node) => {
      node.setAttribute('name', 'twitter:description')
      node.setAttribute('content', meta.description)
    })
    upsertMeta('link[rel="canonical"]', () => document.createElement('link'), (node) => {
      node.setAttribute('rel', 'canonical')
      node.setAttribute('href', meta.canonical)
    })

    document.head.querySelectorAll('link[data-chicross-alternate]').forEach((node) => node.remove())
    for (const alternate of meta.alternates) {
      const link = document.createElement('link')
      link.setAttribute('rel', 'alternate')
      link.setAttribute('hreflang', alternate.hrefLang)
      link.setAttribute('href', alternate.href)
      link.dataset.chicrossAlternate = 'true'
      document.head.appendChild(link)
    }
    const fallback = document.createElement('link')
    fallback.setAttribute('rel', 'alternate')
    fallback.setAttribute('hreflang', 'x-default')
    fallback.setAttribute('href', meta.alternates[0].href)
    fallback.dataset.chicrossAlternate = 'true'
    document.head.appendChild(fallback)
  }, [meta])
}
